import {
  AfterContentInit,
  ContentChildren,
  Directive,
  OnChanges,
  QueryList,
  SimpleChanges,
  input
} from '@angular/core';
import { RouterLinkActive } from '@angular/router';

@Directive({
    selector: '[routerLink]',

})
export class RouterLinkDirective implements OnChanges, AfterContentInit {
  readonly routerLink = input<any[] | string>(undefined);

  @ContentChildren(RouterLinkActive, { descendants: true })
  linkActives !: QueryList<RouterLinkActive>;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.routerLink && this.linkActives && this.linkActives.first) {
      this.linkActives.first.ngOnChanges(null);
    }
  }

  ngAfterContentInit() {
    this.linkActives.changes.subscribe(_ => this.linkActives.first.ngOnChanges(null));
  }
}
